import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
    TopToolbar,
    DateField,
    EditButton,
    useRecordContext,
    BooleanField,
} from 'react-admin';
import {
    Grid
} from '@mui/material';


const ShowActions = () => {

    return (
        <TopToolbar>
            <EditButton />
        </TopToolbar>
    );
}

const ShowPeopleTitle = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>{ "Companies House People - " + record.name }</span>
}

export const AdminCompaniesHousePeopleShow = () => {
    return (
        <Show actions={ <ShowActions /> } title={ <ShowPeopleTitle /> }>

            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="id" />
                        <TextField source="name" />
                        <TextField source="role" />
                        <DateField source="appointedOn" />
                    </SimpleShowLayout>
                </Grid>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <BooleanField source="activeDirector" />
                        <BooleanField source="resigned" />
                        <ReferenceField
                            label="Companies House For"
                            source="companiesHouse"
                            reference="companies_house"
                            link="show">
                            <TextField source="companyName" />
                        </ReferenceField>

                    </SimpleShowLayout>
                </Grid>
            </Grid>
        </Show>
    );
}